import moment from 'moment';

export const getWeekMonthStart = (date: string) =>
  moment(date).isoWeekday(4).startOf('month').format('YYYY-MM-DD');
